import React from "react";

const HospDischarge = ({ formData, handleChange, dtDisplay }) => {
  // 라디오 버튼 전용 핸들러 - 간단한 재클릭 해제 로직
  const handleRadioClick = (e) => {
    const { name, value } = e.target;

    // 현재 선택된 값과 클릭된 값이 같으면 해제, 다르면 선택
    if (formData[name] === value) {
      handleChange({ target: { name, value: "" } });
    } else {
      handleChange({ target: { name, value } });
    }
  };

  // 복사-붙여넣기 자동 포맷팅 핸들러 (Date 전용)
  const handleDatePaste = (e, fieldName) => {
    e.preventDefault(); // 기본 붙여넣기 동작 방지

    const pastedData = e.clipboardData.getData("text");
    const numbers = pastedData.replace(/\D/g, ""); // 숫자만 추출

    if (numbers.length <= 8) {
      // YYYYMMDD 최대 8자리
      let formattedValue = numbers;

      if (numbers.length >= 4) {
        formattedValue = numbers.slice(0, 4) + "-" + numbers.slice(4);
      }
      if (numbers.length >= 6) {
        formattedValue =
          formattedValue.slice(0, 7) + "-" + formattedValue.slice(7);
      }

      // 포맷된 값으로 필드 업데이트
      handleChange({
        target: { name: fieldName, value: formattedValue },
      });
    }
  };

  return (
    <section className="vip-form-section">
      <div className="basic-info-fieldset">
        <h3 className="section-subtitle">Hospital Discharge</h3>

        {/* 퇴원시 사망 여부 */}
        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              퇴원시 사망 여부 (dis_status)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {[
                  { label: "Dead", value: "Dead" },
                  { label: "Alive", value: "Alive" },
                ].map((option) => (
                  <label key={option.value} className="rad-label vertical">
                    <input
                      type="radio"
                      className="rad-input"
                      name="dis_status"
                      value={option.value}
                      checked={formData.dis_status === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
          <div className="block-2column">
            <label className="item_title_2col">퇴원 장소 (dis_to)</label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {[
                  { label: "Home", value: "Home" },
                  {
                    label: "Transfer to other hospital",
                    value: "Transfer to other hospital",
                  },
                  {
                    label: "Transfer to other department",
                    value: "Transfer to other department",
                  },
                  { label: "Expired", value: "Expired" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="dis_to"
                      value={option.value}
                      checked={formData.dis_to === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* 퇴원 일자 */}
        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">퇴원 일자 (dis_d)</label>
            <div className="input_2col">
              <input
                type="text"
                name="dis_d"
                placeholder="YYYY-MM-DD"
                value={dtDisplay(formData.dis_d)}
                onChange={handleChange}
                onPaste={(e) => handleDatePaste(e, "dis_d")}
              />
            </div>
          </div>
          <div className="block-2column">
            <label className="item_title_2col">
              Brain death 여부 (braindeath)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {[
                  { label: "No", value: "No" },
                  { label: "Yes", value: "Yes" },
                ].map((option) => (
                  <label key={option.value} className="rad-label vertical">
                    <input
                      type="radio"
                      className="rad-input"
                      name="braindeath"
                      value={option.value}
                      checked={formData.braindeath === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Brain death 판정 일시 */}
        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              Brain death 판정 일시 (braindeath_d)
            </label>
            <div className="input_2col">
              <input
                type="text"
                name="braindeath_d"
                placeholder="YYYY-MM-DD"
                value={dtDisplay(formData.braindeath_d)}
                onChange={handleChange}
                onPaste={(e) => handleDatePaste(e, "braindeath_d")}
              />
            </div>
          </div>
          <div className="block-2column">
            <label className="item_title_2col">
              장기공여여부 (braindeath_organ)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {[
                  { label: "No", value: "No" },
                  { label: "Yes", value: "Yes" },
                ].map((option) => (
                  <label key={option.value} className="rad-label vertical">
                    <input
                      type="radio"
                      className="rad-input"
                      name="braindeath_organ"
                      value={option.value}
                      checked={formData.braindeath_organ === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* POLST 일자 */}
        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">POLST 일자 (polst_d)</label>
            <div className="input_2col">
              <input
                type="text"
                name="polst_d"
                placeholder="YYYY-MM-DD"
                value={dtDisplay(formData.polst_d)}
                onChange={handleChange}
                onPaste={(e) => handleDatePaste(e, "polst_d")}
              />
            </div>
          </div>
          <div className="block-2column">
            <label className="item_title_2col">POLST 여부 (polst)</label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {[
                  { label: "No", value: "No" },
                  { label: "Yes", value: "Yes" },
                ].map((option) => (
                  <label key={option.value} className="rad-label vertical">
                    <input
                      type="radio"
                      className="rad-input"
                      name="polst"
                      value={option.value}
                      checked={formData.polst === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Completion status */}
        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              Completion status_6 (hosp_discharge_status)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {[
                  { label: "Not started", value: "Not started" },
                  { label: "In process", value: "In process" },
                  { label: "Complete", value: "Complete" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="hosp_discharge_status"
                      value={option.value}
                      checked={formData.hosp_discharge_status === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
          <div className="block-2column" />
        </div>
      </div>
    </section>
  );
};

export default HospDischarge;
